// extracted by mini-css-extract-plugin
module.exports = {"aside":"V_bM","title":"V_S","subTitle":"V_bN","filters":"V_v","row":"V_bP","recommendations":"V_bQ","header":"V_bn","dividerAnimation":"V_p"};